import dayjs from 'dayjs';

export const DayjsFilter = (timestamp: number | null, format: string = '') => {
	if(timestamp === null || format === '') {
		return '';
	}
	return dayjs.unix(timestamp).format(format);
};
